import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import arDict from "@/locales/ar.json";

// Thank You page is ALWAYS in Spanish, regardless of the current app language.
const ThankYouPage = () => {
  const t = (key) =>
    key
      .split(".")
      .reduce((acc, part) => (acc && typeof acc === "object" ? acc[part] : undefined), arDict);

  useEffect(() => {
    document.title = t("pageTitles.thankYou");
  }, []);

  return (
    <main
      data-testid="thank-you-page"
      className="bg-white min-h-[70vh] flex items-center"
      lang="es"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <span
          className="inline-flex items-center justify-center w-16 h-16 bg-[#0B2545] text-white mb-6"
          aria-hidden="true"
        >
          <CheckCircle2 size={28} strokeWidth={2} />
        </span>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#C85A32]">
          {t("thankYou.eyebrow")}
        </p>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#0B2545]">
          {t("thankYou.title")}
        </h1>
        <p className="mt-5 text-base sm:text-lg text-slate-700 leading-relaxed">
          {t("thankYou.subtitle")}
        </p>
        <p className="mt-4 text-base text-slate-600 leading-relaxed">
          {t("thankYou.next")}
        </p>

        <div className="mt-10">
          <Link
            to="/"
            data-testid="thankyou-back-home"
            className="inline-flex items-center justify-center gap-2 bg-[#0B2545] text-white px-6 py-3 text-sm font-semibold tracking-wide hover:bg-[#133763]"
          >
            <ArrowLeft size={16} />
            {t("thankYou.backHome")}
          </Link>
        </div>
      </div>
    </main>
  );
};

export default ThankYouPage;
